/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/einkaufs-statitik-web-details/shop.einkaufs-statitik-web-details.component.ts.
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {View} from '../../../../models/view';
import {ShopViewComponent} from '../view/shop.view.component';
import {AppMobileService} from '../../../../services/app.mobile.service';
import {AppEventService} from '../../../../services/app.event.service';
import {EinkaufsStatistikWeb} from '../../models/einkaufs-statistik-web';

/**
 * Zweck: Beschreibt class ShopEinkaufsStatitikWebDetailsComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // tslint:disable-next-line:component-selector
    selector: 'einkaufs-statitik-web-details',
    templateUrl: 'shop.einkaufs-statitik-web-details.component.html',
    styleUrls: ['shop.einkaufs-statitik-web-details.component.scss'],
    standalone: false
})
export class ShopEinkaufsStatitikWebDetailsComponent implements OnChanges, OnInit {
  @Input() statistik: EinkaufsStatistikWeb[];
  @Input() view: View;
  @Input() viewcomp: ShopViewComponent;
  @Input() actions = true;

  months = Array.from({ length: 12 }, (_, i) => i + 1);

  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth() + 1;

  highlightYear = this.currentYear;

  highlightMonthMonth = this.currentMonth;
  highlightMonthYear = this.currentYear;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private cd: ChangeDetectorRef, public msvc: AppMobileService, private esv: AppEventService) {
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {

  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {

  }
}
